
// import React, { useEffect, useState, useRef } from "react";
// import {
//   Tabs,
//   Tab,
//   Box,
//   Grid,
//   TextField,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Typography,
// } from "@mui/material";
// import ParkList from "../../Shared/PreRenderedComponents/ParkList";
// import FormContainer from "../../../../components/Forms/FormContainer";
// import {
//   ExecutePostWithParams,
//   GetDataFromApiWithParams,
// } from "../../../../services/api/ExecuteApiRequests";
// import { IPDCAttachFileWithReset } from "../../../../components/Controls";

// function ParcelManagement({ filterAvailableOnly = false }) {
//   const [tabIndex, setTabIndex] = useState(0);

//   // Split park state per tab
//   const [reservePark, setReservePark] = useState(null);
//   const [releasePark, setReleasePark] = useState(null);

//   // Reserve tab state
//   const [parcelInPark, setParcelInPark] = useState([]);
//   const [reserveUpin, setReserveUpin] = useState(null);

//   // Release tab state
//   const [reservedParcels, setReservedParcels] = useState([]);
//   const [releaseUpin, setReleaseUpin] = useState(null);

//   // Shared state
//   const [description, setDescription] = useState("");
//   const [attachment, setAttachment] = useState(null);
//   const fileInputRef = useRef();
//   const [message, setMessage] = useState(null);

//   const handleTabChange = (event, newValue) => {
//     setTabIndex(newValue);
//     setMessage(null);
//     setDescription("");
//     setAttachment(null);
//     setParcelInPark([]);
//     setReservedParcels([]);
//     setReserveUpin(null);
//     setReleaseUpin(null);
//     if (fileInputRef.current) fileInputRef.current.reset();
//   };

//   // Fetch parcels for reservation
//   useEffect(() => {
//     const fetchAvailableParcels = async (parkId) => {
//       try {
//         const responseData = await GetDataFromApiWithParams(`availableParcelsInPark/${parkId}`);
//         if (responseData) {
//           let finalData = responseData;
//           console.log("Available Parcels:", finalData);
          
//           // Apply the same filtering logic as original code
//           if (filterAvailableOnly) {
//             finalData = finalData.filter(item => item.status !== "reserved" && item.status === "Operational");
//           }
//           setParcelInPark(finalData);
//         }
//       } catch (error) {
//         console.error(error);
//         setParcelInPark([]);
//       }
//     };

//     if (reservePark) {
//       fetchAvailableParcels(reservePark.id);
//     } else {
//       setParcelInPark([]);
//     }
//   }, [reservePark, filterAvailableOnly]);

//   // Fetch parcels for release
//   useEffect(() => {
//     const fetchReservedParcels = async (parkId) => {
//       try {
//         const responseData = await GetDataFromApiWithParams(`reservedParcelsInPark/${parkId}`);
//         console.log("Reserved Parcels Response:", responseData);
//         if (Array.isArray(responseData)) {
//           const nonActiveParcels = responseData.filter(item => item.status !== "ACTIVE");
//           setReservedParcels(nonActiveParcels);
//         } else {
//           setReservedParcels([]);
//         }
//       } catch (error) {
//         console.error(error);
//         setReservedParcels([]);
//       }
//     };

//     if (releasePark) {
//       fetchReservedParcels(releasePark.id);
//     } else {
//       setReservedParcels([]);
//     }
//   }, [releasePark]);

//   // Reserve parcel submit
//   const handleReserveSubmit = async (e) => {
//     e.preventDefault();
//     const formData = new FormData();
//     formData.append("upin", reserveUpin);
//     formData.append("description", description);
//     formData.append("file", attachment);

//     try {
//       const responseData = await ExecutePostWithParams(`parcels/${reserveUpin}/placeOnHold`, formData, true);
//       if (responseData) {
//         setMessage(<Typography sx={{ color: "green" }}>Parcel placed on hold successfully!</Typography>);
//         setReservePark(null);
//         setReserveUpin(null);
//         setDescription("");
//         setAttachment(null);
//         setParcelInPark([]);
//         if (fileInputRef.current) fileInputRef.current.reset();
//       }
//     } catch (error) {
//       setMessage(<Typography sx={{ color: "red" }}>Something went wrong, Please try again!</Typography>);
//       console.error(error);
//     }
//   };

//   // Release parcel submit
//   const handleReleaseSubmit = async (e) => {
//     e.preventDefault();
//     const formData = new FormData();
//     formData.append("upin", releaseUpin);

//     try {
//       const responseData = await ExecutePostWithParams(`parcels/${releaseUpin}/placeOnHoldRelease`, formData, true);
//       if (responseData) {
//         setMessage(<Typography sx={{ color: "green" }}>Parcel released successfully!</Typography>);
//         setReleasePark(null);
//         setReleaseUpin(null);
//         setReservedParcels([]);
//         if (fileInputRef.current) fileInputRef.current.reset();
//       }
//     } catch (error) {
//       setMessage(<Typography sx={{ color: "red" }}>Something went wrong, Please try again!</Typography>);
//       console.error(error);
//     }
//   };

//   return (
//     <Box sx={{ width: "100%" }}>
//       <Tabs value={tabIndex} onChange={handleTabChange} aria-label="parcel management tabs">
//         <Tab label="Reserve Parcel" sx={{ fontSize: "0.875rem", fontWeight: "bold", textTransform: "none" }} />
//         <Tab label="Release Parcel" sx={{ fontSize: "0.875rem", fontWeight: "bold", textTransform: "none" }} />
//       </Tabs>

//       <Box sx={{ p: 3 }}>
//         {tabIndex === 0 && (
//           <FormContainer title="Reserve Parcel" onSubmit={handleReserveSubmit} buttonLabel="Reserve Parcel">
//             <Grid container spacing={2}>
//               <Grid item xs={12}>
//                 <ParkList selectedPark={reservePark} setSelectedPark={setReservePark} />
//               </Grid>
//               <Grid item xs={12}>
//                 <FormControl fullWidth>
//                   <InputLabel id="reserve-upin-label">Parcel UPIN</InputLabel>
//                   <Select
//                     labelId="reserve-upin-label"
//                     id="reserve-upin"
//                     value={reserveUpin || ""}
//                     onChange={(e) => setReserveUpin(e.target.value)}
//                     required
//                   >
//                     <MenuItem value="">
//                       <em>Select Parcel UPIN</em>
//                     </MenuItem>
//                     {parcelInPark.map(parcel => (
//                       <MenuItem key={parcel.upin} value={parcel.upin}>
//                         {parcel.upin}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   margin="normal"
//                   label="Description"
//                   value={description}
//                   onChange={(e) => setDescription(e.target.value)}
//                   multiline
//                   rows={4}
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <IPDCAttachFileWithReset
//                   ref={fileInputRef}
//                   onChange={(files) => setAttachment(files[0])}
//                   isMultiple={true}
//                   isRequired={false}
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <Typography color={"red"} align="right">Please note this reservation will expire in 30 days</Typography>
//               </Grid>
//               {message && (
//                 <Grid item xs={12}>
//                   {message}
//                 </Grid>
//               )}
//             </Grid>
//           </FormContainer>
//         )}

//         {tabIndex === 1 && (
//           <FormContainer title="Release Parcel" onSubmit={handleReleaseSubmit} buttonLabel="Release Parcel">
//             <Grid container spacing={2}>
//               <Grid item xs={12}>
//                 <ParkList selectedPark={releasePark} setSelectedPark={setReleasePark} />
//               </Grid>
//               <Grid item xs={12}>
//                 <FormControl fullWidth>
//                   <InputLabel id="release-upin-label">Parcel UPIN</InputLabel>
//                   <Select
//                     labelId="release-upin-label"
//                     id="release-upin"
//                     value={releaseUpin || ""}
//                     onChange={(e) => setReleaseUpin(e.target.value)}
//                     required
//                   >
//                     <MenuItem value="">
//                       <em>Select Parcel UPIN</em>
//                     </MenuItem>
//                     {reservedParcels.length > 0 ? (
//                       reservedParcels.map(parcel => (
//                         <MenuItem key={parcel.upin} value={parcel.upin}>
//                           {parcel.upin}
//                         </MenuItem>
//                       ))
//                     ) : (
//                       <MenuItem value="" disabled>
//                         <em>No reserved parcels available</em>
//                       </MenuItem>
//                     )}
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   margin="normal"
//                   label="Description"
//                   value={description}
//                   onChange={(e) => setDescription(e.target.value)}
//                   multiline
//                   rows={4}
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <IPDCAttachFileWithReset
//                   ref={fileInputRef}
//                   onChange={(files) => setAttachment(files[0])}
//                   isMultiple={true}
//                   isRequired={false}
//                 />
//               </Grid>
//               {message && (
//                 <Grid item xs={12}>
//                   {message}
//                 </Grid>
//               )}
//             </Grid>
//           </FormContainer>
//         )}
//       </Box>
//     </Box>
//   );
// }

// export default ParcelManagement;
// //#######################################
// import React, { useState, useRef, useCallback, forwardRef } from "react";
// import { 
//   Box, 
//   ToggleButton, 
//   ToggleButtonGroup, 
//   Typography, 
//   Paper,
//   Grid,
//   TextField,
//   Button
// } from "@mui/material";
// import { ExecutePostWithParams } from "../../../../services/api/ExecuteApiRequests";
// import { IPDCAttachFileWithReset, IPDCToastMessageResult } from "../../../../components/Controls";
// import { FloatingRightSingleFormNearTop } from "../../../../styles/Form/FormStyles";
// import ViewMap from "../../LandInfraDevelopment/GISView/MapRelated/Views/ViewMap";

// // Reserve Parcel Form
// const ReserveParcelForm = forwardRef(({ selectedFeatureOnMap }, ref) => {
//   const [upin, setUpin] = useState("");
//   const [description, setDescription] = useState("");
//   const [attachment, setAttachment] = useState(null);
//   const [responseMessage, setResponseMessage] = useState("");
//   const [alertSeverity, setAlertSeverity] = useState("info");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const fileInputRef = useRef();

//   // Handle map selection - validate if parcel can be reserved
//   React.useEffect(() => {
//     if (selectedFeatureOnMap && selectedFeatureOnMap.length > 0) {
//       const feature = selectedFeatureOnMap[0];
//       const upinFromMap = feature.get("upin") || "";
//       const parcelStatus = feature.get("status") || "";
//       const occupancyStatus = feature.get("occupancy_status") || "";
      
//       if (upinFromMap) {
//         // Check if parcel can be reserved (not occupied and not already reserved)
//         if (occupancyStatus === "Occupied" || parcelStatus === "reserved") {
//           showToastMessage("This parcel cannot be reserved. It is either occupied or already reserved.", "warning");
//           setUpin(""); // Clear the UPIN field
//         } else {
//           setUpin(upinFromMap);
//           // No toast message for successful selection
//         }
//       }
//     }
//   }, [selectedFeatureOnMap]);

//   const clearMessage = useCallback(() => {
//     const timer = setTimeout(() => {
//       setResponseMessage("");
//       setAlertSeverity("info");
//     }, 5000);
//     return () => clearTimeout(timer);
//   }, []);

//   const showToastMessage = useCallback((message, severity) => {
//     setResponseMessage("");
//     setTimeout(() => {
//       setResponseMessage(message);
//       setAlertSeverity(severity);
//       clearMessage();
//     }, 10);
//   }, [clearMessage]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (isSubmitting) {
//       showToastMessage("Please wait, previous request is processing...", "info");
//       return;
//     }
    
//     setIsSubmitting(true);

//     try {
//       if (!upin.trim()) {
//         showToastMessage("Please select an available parcel by clicking on the map", "warning");
//         setIsSubmitting(false);
//         return;
//       }

//       const formData = new FormData();
//       formData.append("upin", upin);
//       formData.append("description", description);
//       if (attachment) {
//         formData.append("file", attachment);
//       }

//       const responseData = await ExecutePostWithParams(`parcels/${upin}/placeOnHold`, formData, true);

//       if (responseData) {
//         showToastMessage("Parcel placed on hold successfully!", "success");
//         resetForm();
//       } else {
//         showToastMessage("Reservation failed!", "error");
//       }
//     } catch (error) {
//       console.error(error);
//       showToastMessage(`Reservation failed: ${error.message}`, "error");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const resetForm = () => {
//     setUpin("");
//     setDescription("");
//     setAttachment(null);
//     if (fileInputRef.current) {
//       fileInputRef.current.reset();
//     }
//   };

//   return (
//     <Paper sx={{ ...FloatingRightSingleFormNearTop }} elevation={3}>
//       <Typography variant="h5" gutterBottom align="center">
//         Reserve Parcel
//       </Typography>
//       <Typography variant="body2" color="textSecondary" sx={{ mb: 2, textAlign: "center" }}>
//         Select available parcels (not occupied/orange colored)
//       </Typography>
//       <form onSubmit={handleSubmit} ref={ref}>
//         <Grid container spacing={1}>
//           <Grid item xs={12}>
//             <TextField 
//               fullWidth 
//               label="Parcel UPIN" 
//               variant="outlined" 
//               value={upin} 
//               onChange={e => setUpin(e.target.value)} 
//               required 
//               helperText="Click on an available parcel (not orange) in the map"
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField 
//               fullWidth 
//               label="Description" 
//               variant="outlined" 
//               multiline 
//               rows={3} 
//               value={description} 
//               onChange={e => setDescription(e.target.value)} 
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <IPDCAttachFileWithReset 
//               ref={fileInputRef}
//               onChange={files => setAttachment(files[0])} 
//               isMultiple={true} 
//               isRequired={false}
//               label="Attach Document"
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Typography color={"red"} variant="body2" align="right">
//               Please note this reservation will expire in 30 days
//             </Typography>
//           </Grid>
//           <Grid item xs={12}>
//             <Button 
//               type="submit" 
//               variant="contained" 
//               color="primary" 
//               fullWidth
//               disabled={isSubmitting}
//             >
//               {isSubmitting ? "Reserving..." : "Reserve Parcel"}
//             </Button>
//           </Grid>
//         </Grid>
//       </form>
      
//       {responseMessage && (
//         <IPDCToastMessageResult 
//           message={responseMessage} 
//           type={alertSeverity} 
//           onClose={() => setResponseMessage("")}
//         />
//       )}
//     </Paper>
//   );
// });

// // Release Parcel Form
// const ReleaseParcelForm = forwardRef(({ selectedFeatureOnMap }, ref) => {
//   const [upin, setUpin] = useState("");
//   const [description, setDescription] = useState("");
//   const [attachment, setAttachment] = useState(null);
//   const [responseMessage, setResponseMessage] = useState("");
//   const [alertSeverity, setAlertSeverity] = useState("info");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const fileInputRef = useRef();

//   // Handle map selection - validate if parcel can be released
//   React.useEffect(() => {
//     if (selectedFeatureOnMap && selectedFeatureOnMap.length > 0) {
//       const feature = selectedFeatureOnMap[0];
     
//       const upinFromMap = feature.get("upin") || "";
//       const parcelStatus = feature.get("occupancy_status") || "";
      
//       if (upinFromMap) {
//         // Check if parcel can be released (must be reserved status)
//         if (parcelStatus !== "Reserved") {
//           showToastMessage("This parcel is not reserved and cannot be released.", "warning");
//           setUpin(""); // Clear the UPIN field
//         } else {
//           setUpin(upinFromMap);
//           // No toast message for successful selection
//         }
//       }
//     }
//   }, [selectedFeatureOnMap]);

//   const clearMessage = useCallback(() => {
//     const timer = setTimeout(() => {
//       setResponseMessage("");
//       setAlertSeverity("info");
//     }, 5000);
//     return () => clearTimeout(timer);
//   }, []);

//   const showToastMessage = useCallback((message, severity) => {
//     setResponseMessage("");
//     setTimeout(() => {
//       setResponseMessage(message);
//       setAlertSeverity(severity);
//       clearMessage();
//     }, 10);
//   }, [clearMessage]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (isSubmitting) {
//       showToastMessage("Please wait, previous request is processing...", "info");
//       return;
//     }
    
//     setIsSubmitting(true);

//     try {
//       if (!upin.trim()) {
//         showToastMessage("Please select a reserved parcel by clicking on the map", "warning");
//         setIsSubmitting(false);
//         return;
//       }

//       const formData = new FormData();
//       formData.append("upin", upin);
//       if (description) {
//         formData.append("description", description);
//       }
//       if (attachment) {
//         formData.append("file", attachment);
//       }

//       const responseData = await ExecutePostWithParams(`parcels/${upin}/placeOnHoldRelease`, formData, true);

//       if (responseData) {
//         showToastMessage("Parcel released successfully!", "success");
//         resetForm();
//       } else {
//         showToastMessage("Release failed!", "error");
//       }
//     } catch (error) {
//       console.error(error);
//       showToastMessage(`Release failed: ${error.message}`, "error");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const resetForm = () => {
//     setUpin("");
//     setDescription("");
//     setAttachment(null);
//     if (fileInputRef.current) {
//       fileInputRef.current.reset();
//     }
//   };

//   return (
//     <Paper sx={{ ...FloatingRightSingleFormNearTop }} elevation={3}>
//       <Typography variant="h5" gutterBottom align="center">
//         Release Parcel
//       </Typography>
//       <Typography variant="body2" color="textSecondary" sx={{ mb: 2, textAlign: "center" }}>
//         Select reserved parcels only
//       </Typography>
//       <form onSubmit={handleSubmit} ref={ref}>
//         <Grid container spacing={1}>
//           <Grid item xs={12}>
//             <TextField 
//               fullWidth 
//               label="Parcel UPIN" 
//               variant="outlined" 
//               value={upin} 
//               onChange={e => setUpin(e.target.value)} 
//               required 
//               helperText="Click on a reserved parcel in the map"
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField 
//               fullWidth 
//               label="Description" 
//               variant="outlined" 
//               multiline 
//               rows={3} 
//               value={description} 
//               onChange={e => setDescription(e.target.value)} 
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <IPDCAttachFileWithReset 
//               ref={fileInputRef}
//               onChange={files => setAttachment(files[0])} 
//               isMultiple={true} 
//               isRequired={false}
//               label="Attach Document"
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Button 
//               type="submit" 
//               variant="contained" 
//               color="primary" 
//               fullWidth
//               disabled={isSubmitting}
//             >
//               {isSubmitting ? "Releasing..." : "Release Parcel"}
//             </Button>
//           </Grid>
//         </Grid>
//       </form>
      
//       {responseMessage && (
//         <IPDCToastMessageResult 
//           message={responseMessage} 
//           type={alertSeverity} 
//           onClose={() => setResponseMessage("")}
//         />
//       )}
//     </Paper>
//   );
// });

// // Main Component
// const ParcelReservationRelease = () => {
//   const [selectedFeatureOnMap, setSelectedFeatureOnMap] = useState(null);
//   const [showReserveForm, setShowReserveForm] = useState(false);
//   const [showReleaseForm, setShowReleaseForm] = useState(false);
//   const [showProposeForm, setShowProposeForm] = useState(false);

//   const handleReserveButton = () => {
//     setShowReserveForm(!showReserveForm);
//     if (showReleaseForm) {
//       setShowReleaseForm(false);
//       setShowProposeForm(false)
//     }
//     console.log("show Reserve form");
//   };

//   const handleReleaseButton = () => {
//     setShowReleaseForm(!showReleaseForm);
//     if (showReserveForm) {
//       setShowReserveForm(false);
//       setShowProposeForm(false);
//     }
//     console.log("show Release form");
//   };
//   const handleProposeButton = () => {
//     setShowReleaseForm(!showProposeForm);
    
//     if (showProposeForm) {
//       setShowReserveForm(false);
//       setShowReleaseForm(false);
//     }
//     console.log("show Release form");
//   };

//   return (
//     <>
//       <Box>
//         <ToggleButtonGroup exclusive sx={{ float: "right", position: "fixed", right: 10, zIndex: 1000000 }}>
//           <ToggleButton 
//             key={"Reserve"} 
//             value={"Reserve"} 
//             onClick={handleReserveButton}
//             selected={showReserveForm}
//           >
//             <Typography color={showReserveForm ? "primary" : "gray"}>
//               Reserve Parcel
//             </Typography>
//           </ToggleButton>
//           <ToggleButton 
//             key={"Release"} 
//             value={"Release"} 
//             onClick={handleReleaseButton}
//             selected={showReleaseForm}
//           >
//             <Typography color={showReleaseForm ? "primary" : "gray"}>
//               Release Parcel
//             </Typography>
//           </ToggleButton>
//            <ToggleButton 
//             key={"propose"} 
//             value={"propose"} 
//             onClick={handleProposeButton}
//             selected={showProposeForm}
//           >
//             <Typography color={showReleaseForm ? "primary" : "gray"}>
//               Proposed Parcel
//             </Typography>
//           </ToggleButton>
//         </ToggleButtonGroup>
//       </Box>

//       {showReserveForm && <ReserveParcelForm selectedFeatureOnMap={selectedFeatureOnMap} />}
//       {showReleaseForm && <ReleaseParcelForm selectedFeatureOnMap={selectedFeatureOnMap} />}

//       <Box sx={{ position: "relative", height: "90vh", overflow: "visible" }}>
//         <ViewMap
//           setSelectedFeatureOnMap={setSelectedFeatureOnMap}
//           isEditable={false}
//           showLegend={true}
//           showPopup={false}
//         />
//       </Box>
//     </>
//   );
// };

// export default React.memo(ParcelReservationRelease);

// import React, { useState, useRef, useCallback, forwardRef } from "react";
// import { 
//   Box, 
//   ToggleButton, 
//   ToggleButtonGroup, 
//   Typography, 
//   Paper,
//   Grid,
//   TextField,
//   Button
// } from "@mui/material";
// import { ExecutePostWithParams } from "../../../../services/api/ExecuteApiRequests";
// import { IPDCAttachFileWithReset, IPDCToastMessageResult } from "../../../../components/Controls";
// import { FloatingRightSingleFormNearTop } from "../../../../styles/Form/FormStyles";
// import ViewMap from "../../LandInfraDevelopment/GISView/MapRelated/Views/ViewMap";

// // Reserve Parcel Form
// const ReserveParcelForm = forwardRef(({ selectedFeatureOnMap }, ref) => {
//   const [upin, setUpin] = useState("");
//   const [description, setDescription] = useState("");
//   const [attachment, setAttachment] = useState(null);
//   const [responseMessage, setResponseMessage] = useState("");
//   const [alertSeverity, setAlertSeverity] = useState("info");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const fileInputRef = useRef();

//   // Handle map selection - validate if parcel can be reserved
//   React.useEffect(() => {
//     if (selectedFeatureOnMap && selectedFeatureOnMap.length > 0) {
//       const feature = selectedFeatureOnMap[0];
//       const upinFromMap = feature.get("upin") || "";
//       const parcelStatus = feature.get("status") || "";
//       const occupancyStatus = feature.get("occupancy_status") || "";
      
//       if (upinFromMap) {
//         // Check if parcel can be reserved (not occupied and not already reserved)
//         if (occupancyStatus === "Occupied" || parcelStatus === "reserved") {
//           showToastMessage("This parcel cannot be reserved. It is either occupied or already reserved.", "warning");
//           setUpin(""); // Clear the UPIN field
//         } else {
//           setUpin(upinFromMap);
//           // No toast message for successful selection
//         }
//       }
//     }
//   }, [selectedFeatureOnMap]);

//   const clearMessage = useCallback(() => {
//     const timer = setTimeout(() => {
//       setResponseMessage("");
//       setAlertSeverity("info");
//     }, 5000);
//     return () => clearTimeout(timer);
//   }, []);

//   const showToastMessage = useCallback((message, severity) => {
//     setResponseMessage("");
//     setTimeout(() => {
//       setResponseMessage(message);
//       setAlertSeverity(severity);
//       clearMessage();
//     }, 10);
//   }, [clearMessage]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (isSubmitting) {
//       showToastMessage("Please wait, previous request is processing...", "info");
//       return;
//     }
    
//     setIsSubmitting(true);

//     try {
//       if (!upin.trim()) {
//         showToastMessage("Please select an available parcel by clicking on the map", "warning");
//         setIsSubmitting(false);
//         return;
//       }

//       const formData = new FormData();
//       formData.append("upin", upin);
//       formData.append("description", description);
//       if (attachment) {
//         formData.append("file", attachment);
//       }

//       const responseData = await ExecutePostWithParams(`parcels/${upin}/placeOnHold`, formData, true);

//       if (responseData) {
//         showToastMessage("Parcel placed on hold successfully!", "success");
//         resetForm();
//       } else {
//         showToastMessage("Reservation failed!", "error");
//       }
//     } catch (error) {
//       console.error(error);
//       showToastMessage(`Reservation failed: ${error.message}`, "error");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const resetForm = () => {
//     setUpin("");
//     setDescription("");
//     setAttachment(null);
//     if (fileInputRef.current) {
//       fileInputRef.current.reset();
//     }
//   };

//   return (
//     <Paper sx={{ ...FloatingRightSingleFormNearTop }} elevation={3}>
//       <Typography variant="h5" gutterBottom align="center">
//         Reserve Parcel
//       </Typography>
//       <Typography variant="body2" color="textSecondary" sx={{ mb: 2, textAlign: "center" }}>
//         Select available parcels (not occupied/orange colored)
//       </Typography>
//       <form onSubmit={handleSubmit} ref={ref}>
//         <Grid container spacing={1}>
//           <Grid item xs={12}>
//             <TextField 
//               fullWidth 
//               label="Parcel UPIN" 
//               variant="outlined" 
//               value={upin} 
//               onChange={e => setUpin(e.target.value)} 
//               required 
//               helperText="Click on an available parcel (not orange) in the map"
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField 
//               fullWidth 
//               label="Description" 
//               variant="outlined" 
//               multiline 
//               rows={3} 
//               value={description} 
//               onChange={e => setDescription(e.target.value)} 
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <IPDCAttachFileWithReset 
//               ref={fileInputRef}
//               onChange={files => setAttachment(files[0])} 
//               isMultiple={true} 
//               isRequired={false}
//               label="Attach Document"
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Typography color={"red"} variant="body2" align="right">
//               Please note this reservation will expire in 30 days
//             </Typography>
//           </Grid>
//           <Grid item xs={12}>
//             <Button 
//               type="submit" 
//               variant="contained" 
//               color="primary" 
//               fullWidth
//               disabled={isSubmitting}
//             >
//               {isSubmitting ? "Reserving..." : "Reserve Parcel"}
//             </Button>
//           </Grid>
//         </Grid>
//       </form>
      
//       {responseMessage && (
//         <IPDCToastMessageResult 
//           message={responseMessage} 
//           type={alertSeverity} 
//           onClose={() => setResponseMessage("")}
//         />
//       )}
//     </Paper>
//   );
// });

// // Release Parcel Form
// const ReleaseParcelForm = forwardRef(({ selectedFeatureOnMap }, ref) => {
//   const [upin, setUpin] = useState("");
//   const [description, setDescription] = useState("");
//   const [attachment, setAttachment] = useState(null);
//   const [responseMessage, setResponseMessage] = useState("");
//   const [alertSeverity, setAlertSeverity] = useState("info");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const fileInputRef = useRef();

//   // Handle map selection - validate if parcel can be released
//   React.useEffect(() => {
//     if (selectedFeatureOnMap && selectedFeatureOnMap.length > 0) {
//       const feature = selectedFeatureOnMap[0];
//       const upinFromMap = feature.get("upin") || "";
//       const parcelStatus = feature.get("occupancy_status") || "";
      
//       if (upinFromMap) {
//         // Check if parcel can be released (must be reserved status)
//         if (parcelStatus !== "Reserved") {
//           showToastMessage("This parcel is not reserved and cannot be released.", "warning");
//           setUpin(""); // Clear the UPIN field
//         } else {
//           setUpin(upinFromMap);
//           // No toast message for successful selection
//         }
//       }
//     }
//   }, [selectedFeatureOnMap]);

//   const clearMessage = useCallback(() => {
//     const timer = setTimeout(() => {
//       setResponseMessage("");
//       setAlertSeverity("info");
//     }, 5000);
//     return () => clearTimeout(timer);
//   }, []);

//   const showToastMessage = useCallback((message, severity) => {
//     setResponseMessage("");
//     setTimeout(() => {
//       setResponseMessage(message);
//       setAlertSeverity(severity);
//       clearMessage();
//     }, 10);
//   }, [clearMessage]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (isSubmitting) {
//       showToastMessage("Please wait, previous request is processing...", "info");
//       return;
//     }
    
//     setIsSubmitting(true);

//     try {
//       if (!upin.trim()) {
//         showToastMessage("Please select a reserved parcel by clicking on the map", "warning");
//         setIsSubmitting(false);
//         return;
//       }

//       const formData = new FormData();
//       formData.append("upin", upin);
//       if (description) {
//         formData.append("description", description);
//       }
//       if (attachment) {
//         formData.append("file", attachment);
//       }

//       const responseData = await ExecutePostWithParams(`parcels/${upin}/placeOnHoldRelease`, formData, true);

//       if (responseData) {
//         showToastMessage("Parcel released successfully!", "success");
//         resetForm();
//       } else {
//         showToastMessage("Release failed!", "error");
//       }
//     } catch (error) {
//       console.error(error);
//       showToastMessage(`Release failed: ${error.message}`, "error");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const resetForm = () => {
//     setUpin("");
//     setDescription("");
//     setAttachment(null);
//     if (fileInputRef.current) {
//       fileInputRef.current.reset();
//     }
//   };

//   return (
//     <Paper sx={{ ...FloatingRightSingleFormNearTop }} elevation={3}>
//       <Typography variant="h5" gutterBottom align="center">
//         Release Parcel
//       </Typography>
//       <Typography variant="body2" color="textSecondary" sx={{ mb: 2, textAlign: "center" }}>
//         Select reserved parcels only
//       </Typography>
//       <form onSubmit={handleSubmit} ref={ref}>
//         <Grid container spacing={1}>
//           <Grid item xs={12}>
//             <TextField 
//               fullWidth 
//               label="Parcel UPIN" 
//               variant="outlined" 
//               value={upin} 
//               onChange={e => setUpin(e.target.value)} 
//               required 
//               helperText="Click on a reserved parcel in the map"
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <TextField 
//               fullWidth 
//               label="Description" 
//               variant="outlined" 
//               multiline 
//               rows={3} 
//               value={description} 
//               onChange={e => setDescription(e.target.value)} 
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <IPDCAttachFileWithReset 
//               ref={fileInputRef}
//               onChange={files => setAttachment(files[0])} 
//               isMultiple={true} 
//               isRequired={false}
//               label="Attach Document"
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Button 
//               type="submit" 
//               variant="contained" 
//               color="primary" 
//               fullWidth
//               disabled={isSubmitting}
//             >
//               {isSubmitting ? "Releasing..." : "Release Parcel"}
//             </Button>
//           </Grid>
//         </Grid>
//       </form>
      
//       {responseMessage && (
//         <IPDCToastMessageResult 
//           message={responseMessage} 
//           type={alertSeverity} 
//           onClose={() => setResponseMessage("")}
//         />
//       )}
//     </Paper>
//   );
// });

// // Propose Parcel Form (Add this component)
// const ProposeParcelForm = forwardRef(({ selectedFeatureOnMap }, ref) => {
//   const [upin, setUpin] = useState("");
//   const [description, setDescription] = useState("");
//   const [attachment, setAttachment] = useState(null);
//   const [responseMessage, setResponseMessage] = useState("");
//   const [alertSeverity, setAlertSeverity] = useState("info");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const fileInputRef = useRef();

//   // Handle map selection for propose form
//   React.useEffect(() => {
//     if (selectedFeatureOnMap && selectedFeatureOnMap.length > 0) {
//       const feature = selectedFeatureOnMap[0];
//       const upinFromMap = feature.get("upin") || "";
      
//       if (upinFromMap) {
//         setUpin(upinFromMap);
//         showToastMessage(`Parcel ${upinFromMap} selected for proposal`, "success");
//       }
//     }
//   }, [selectedFeatureOnMap]);

//   const clearMessage = useCallback(() => {
//     const timer = setTimeout(() => {
//       setResponseMessage("");
//       setAlertSeverity("info");
//     }, 5000);
//     return () => clearTimeout(timer);
//   }, []);

//   const showToastMessage = useCallback((message, severity) => {
//     setResponseMessage("");
//     setTimeout(() => {
//       setResponseMessage(message);
//       setAlertSeverity(severity);
//       clearMessage();
//     }, 10);
//   }, [clearMessage]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (isSubmitting) {
//       showToastMessage("Please wait, previous request is processing...", "info");
//       return;
//     }
    
//     setIsSubmitting(true);

//     try {
//       if (!upin.trim()) {
//         showToastMessage("Please select a parcel by clicking on the map", "warning");
//         setIsSubmitting(false);
//         return;
//       }

//       // Add your propose parcel API call here
//       const formData = new FormData();
//       formData.append("upin", upin);
//       formData.append("description", description);
//       if (attachment) {
//         formData.append("file", attachment);
//       }

//       // Example API call - replace with your actual endpoint
//       const responseData = await ExecutePostWithParams(`parcels/${upin}/propose`, formData, true);

//       if (responseData) {
//         showToastMessage("Parcel proposed successfully!", "success");
//         resetForm();
//       } else {
//         showToastMessage("Proposal failed!", "error");
//       }
//     } catch (error) {
//       console.error(error);
//       showToastMessage(`Proposal failed: ${error.message}`, "error");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const resetForm = () => {
//     setUpin("");
//     setDescription("");
//     setAttachment(null);
//     if (fileInputRef.current) {
//       fileInputRef.current.reset();
//     }
//   };

//   return (
//     <Paper sx={{ ...FloatingRightSingleFormNearTop }} elevation={3}>
//       <Typography variant="h5" gutterBottom align="center">
//         Propose Parcel to Reserve
//       </Typography>
//       <Typography variant="body2" color="textSecondary" sx={{ mb: 2, textAlign: "center" }}>
//         Select parcels for proposal
//       </Typography>
//       <form onSubmit={handleSubmit} ref={ref}>
//         <Grid container spacing={1}>
//           <Grid item xs={12}>
//             <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
//     <label style={{ 
//         display: 'flex', 
//         alignItems: 'center', 
//         gap: '8px',
//         padding: '12px 16px',
//         border: '2px solid #ddd',
//         borderRadius: '8px',
//         cursor: 'pointer',
//         backgroundColor: '#f8f9fa',
//         transition: 'all 0.2s ease'
//     }}>
//         <input 
//             type="checkbox" 
//             // checked={checked1} 
//             // onChange={(e) => setChecked1(e.target.checked)} 
//         />
//         Option 1
//     </label>
    
//     <label style={{ 
//         display: 'flex', 
//         alignItems: 'center', 
//         gap: '8px',
//         padding: '12px 16px',
//         border: '2px solid #ddd',
//         borderRadius: '8px',
//         cursor: 'pointer',
//         backgroundColor: '#f8f9fa',
//         transition: 'all 0.2s ease'
//     }}>
//         <input 
//             type="checkbox" 
//             // checked={checked2} 
//             // onChange={(e) => setChecked2(e.target.checked)} 
//         />
//         Option 2
//     </label>
// </div>
//           </Grid>
//           <Grid item xs={12}>
//             <TextField 
//               fullWidth 
//               label="Description" 
//               variant="outlined" 
//               multiline 
//               rows={3} 
//               value={description} 
//               onChange={e => setDescription(e.target.value)} 
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <IPDCAttachFileWithReset 
//               ref={fileInputRef}
//               onChange={files => setAttachment(files[0])} 
//               isMultiple={true} 
//               isRequired={false}
//               label="Attach Document"
//             />
//           </Grid>
//           <Grid item xs={12}>
//             <Button 
//               type="submit" 
//               variant="contained" 
//               color="primary" 
//               fullWidth
//               disabled={isSubmitting}
//             >
//               {isSubmitting ? "Proposing..." : "Approve Parcel reserve "}
//             </Button>
//           </Grid>
//         </Grid>
//       </form>
      
//       {responseMessage && (
//         <IPDCToastMessageResult 
//           message={responseMessage} 
//           type={alertSeverity} 
//           onClose={() => setResponseMessage("")}
//         />
//       )}
//     </Paper>
//   );
// });

// // Main Component
// const ParcelReservationRelease = () => {
//   const [selectedFeatureOnMap, setSelectedFeatureOnMap] = useState(null);
//   const [showReserveForm, setShowReserveForm] = useState(false);
//   const [showReleaseForm, setShowReleaseForm] = useState(false);
//   const [showProposeForm, setShowProposeForm] = useState(false);

//   const handleReserveButton = () => {
//     setShowReserveForm(!showReserveForm);
//     setShowReleaseForm(false);
//     setShowProposeForm(false);
//     console.log("Reserve form:", !showReserveForm);
//   };

//   const handleReleaseButton = () => {
//     setShowReleaseForm(!showReleaseForm);
//     setShowReserveForm(false);
//     setShowProposeForm(false);
//     console.log("Release form:", !showReleaseForm);
//   };

//   const handleProposeButton = () => {
//     setShowProposeForm(!showProposeForm);
//     setShowReserveForm(false);
//     setShowReleaseForm(false);
//     console.log("Propose form:", !showProposeForm);
//   };

//   return (
//     <>
//       <Box>
//         <ToggleButtonGroup exclusive sx={{ float: "right", position: "fixed", right: 10, zIndex: 1000000 }}>
//           <ToggleButton 
//             key={"Reserve"} 
//             value={"Reserve"} 
//             onClick={handleReserveButton}
//             selected={showReserveForm}
//           >
//             <Typography color={showReserveForm ? "primary" : "gray"}>
//               Reserve Parcel
//             </Typography>
//           </ToggleButton>
//           <ToggleButton 
//             key={"Release"} 
//             value={"Release"} 
//             onClick={handleReleaseButton}
//             selected={showReleaseForm}
//           >
//             <Typography color={showReleaseForm ? "primary" : "gray"}>
//               Release Parcel
//             </Typography>
//           </ToggleButton>
//           <ToggleButton 
//             key={"Propose"} 
//             value={"Propose"} 
//             onClick={handleProposeButton}
//             selected={showProposeForm}
//           >
//             <Typography color={showProposeForm ? "primary" : "gray"}>
//               Propose Parcel
//             </Typography>
//           </ToggleButton>
//         </ToggleButtonGroup>
//       </Box>

//       {showReserveForm && <ReserveParcelForm selectedFeatureOnMap={selectedFeatureOnMap} />}
//       {showReleaseForm && <ReleaseParcelForm selectedFeatureOnMap={selectedFeatureOnMap} />}
//       {showProposeForm && <ProposeParcelForm selectedFeatureOnMap={selectedFeatureOnMap} />}

//       <Box sx={{ position: "relative", height: "90vh", overflow: "visible" }}>
//         <ViewMap
//           setSelectedFeatureOnMap={setSelectedFeatureOnMap}
//           isEditable={false}
//           showLegend={true}
//           showPopup={false}
//         />
//       </Box>
//     </>
//   );
// };

// export default React.memo(ParcelReservationRelease);

// #####################################







import React, { useState, useRef, useCallback, forwardRef } from "react";
import { 
  Box, 
  ToggleButton, 
 ToggleButtonGroup, 
  Typography, 
  Paper,
  Grid,
  TextField,
  Button
} from "@mui/material";
import { ExecutePostWithParams } from "../../../../services/api/ExecuteApiRequests";
import { IPDCAttachFileWithReset, IPDCToastMessageResult } from "../../../../components/Controls";
import { FloatingRightSingleFormNearTop } from "../../../../styles/Form/FormStyles";
import ViewMap from "../../LandInfraDevelopment/GISView/MapRelated/Views/ViewMap";
// ####################################
import useDecodedUser from "../../../../services/hooks/useDecodedUser";

// Parcel Reservation Request Form
const ParcelReservationRequestForm = forwardRef(({ selectedFeatureOnMap }, ref) => {
  const [upin, setUpin] = useState("");
  const [description, setDescription] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [responseMessage, setResponseMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const fileInputRef = useRef();
//   #########################
const decodedUser = useDecodedUser();
// #############

// Safe access to full_name with null check
const fullName = decodedUser?.full_name || "";

console.log("Full Name:", fullName); // This will be safe

  // Handle map selection - validate if parcel can be reserved
  React.useEffect(() => {
    if (selectedFeatureOnMap && selectedFeatureOnMap.length > 0) {
      const feature = selectedFeatureOnMap[0];
      const upinFromMap = feature.get("upin") || "";
      const parcelStatus = feature.get("status") || "";
      const occupancyStatus = feature.get("occupancy_status") || "";
      
      if (upinFromMap) {
        // Check if parcel can be reserved (not occupied and not already reserved)
        if (occupancyStatus === "Occupied" || parcelStatus === "reserved") {
          setUpin(""); // Clear the UPIN field
          showToastMessage(`Parcel ${upinFromMap} cannot be reserved. It is ${occupancyStatus === "Occupied" ? "occupied" : "already reserved"}.`, "warning");
        } else {
          setUpin(upinFromMap);
          // No toast message for successful selection - only show message for invalid parcels
        }
      }
    }
  }, [selectedFeatureOnMap]);

  const clearMessage = useCallback(() => {
    const timer = setTimeout(() => {
      setResponseMessage("");
      setAlertSeverity("info");
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  const showToastMessage = useCallback((message, severity) => {
    setResponseMessage("");
    setTimeout(() => {
      setResponseMessage(message);
      setAlertSeverity(severity);
      clearMessage();
    }, 10);
  }, [clearMessage]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (isSubmitting) {
      showToastMessage("Please wait, previous request is processing...", "info");
      return;
    }
    
    setIsSubmitting(true);

    try {
      if (!upin.trim()) {
        showToastMessage("Please select an available parcel by clicking on the map", "warning");
        setIsSubmitting(false);
        return;
      }

      const formData = new FormData();
      formData.append("upin", upin);
      formData.append("description", description);
      
      // Safe append - only add full_name if it exists
      if (fullName) {
        formData.append("full_name", fullName);
      }
      
      if (attachment) {
        formData.append("file", attachment);
      }

      const responseData = await ExecutePostWithParams(`parcels/${upin}/placeOnHoldRequest`, formData, true);

      if (responseData) {
        showToastMessage("Parcel reservation request submitted successfully!", "success");
        resetForm();
      } else {
        showToastMessage("Reservation request failed!", "error");
      }
    } catch (error) {
      console.error(error);
      showToastMessage(`Reservation request failed: ${error.message}`, "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setUpin("");
    setDescription("");
    setAttachment(null);
    if (fileInputRef.current) {
      fileInputRef.current.reset();
    }
  };

  return (
    <Paper sx={{ 
      ...FloatingRightSingleFormNearTop,
      top: '145px', // Small space from top, aligned with map view top margin
      marginTop: 0
    }} elevation={3}>
      <Typography variant="h5" gutterBottom align="center">
        Parcel Reservation Request
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mb: 2, textAlign: "center" }}>
        Select available parcels (not occupied/orange colored) on the map
      </Typography>
      
      <form onSubmit={handleSubmit} ref={ref}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField 
              fullWidth 
              label="Parcel UPIN" 
              variant="outlined" 
              value={upin} 
              onChange={e => setUpin(e.target.value)} 
              required 
              helperText="Click on an available parcel (not orange) in the map to select it"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField 
              fullWidth 
              label="Description" 
              variant="outlined" 
              multiline 
              rows={3} 
              value={description} 
              onChange={e => setDescription(e.target.value)} 
              placeholder="Provide details about your reservation request..."
            />
          </Grid>
          <Grid item xs={12}>
            <IPDCAttachFileWithReset 
              ref={fileInputRef}
              onChange={files => setAttachment(files[0])} 
              isMultiple={true} 
              isRequired={false}
              label="Attach Supporting Documents"
            />
          </Grid>
          <Grid item xs={12}>
            <Typography color={"red"} variant="body2" align="right">
              Please note: Reservation requests will expire in 30 days
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Button 
              type="submit" 
              variant="contained" 
              color="primary" 
              fullWidth
              disabled={isSubmitting}
              sx={{ mt: 1 }}
            >
              {isSubmitting ? "Submitting Request..." : "Submit Reservation Request"}
            </Button>
          </Grid>
        </Grid>
      </form>
      
      {responseMessage && (
        <IPDCToastMessageResult 
          message={responseMessage} 
          type={alertSeverity} 
          onClose={() => setResponseMessage("")}
        />
      )}
    </Paper>
  );
});

// Main Component
const ParcelReservationRelease = () => {
  const [selectedFeatureOnMap, setSelectedFeatureOnMap] = useState(null);
  const [showReservationForm, setShowReservationForm] = useState(false);

  const handleToggleButton = () => {
    setShowReservationForm(!showReservationForm);
    console.log("Reservation form:", !showReservationForm);
  };

  return (
    <>
      <Box>
        <ToggleButtonGroup exclusive sx={{ 
          float: "right", 
          position: "fixed", 
          right: 10, 
          top: '80px', // Moved toggle button down
          zIndex: 1000000 
        }}>
          <ToggleButton 
            key={"reservation"} 
            value={"reservation"} 
            onClick={handleToggleButton}
            selected={showReservationForm}
            sx={{
              minWidth: '200px',
              backgroundColor: showReservationForm ? 'grey.400' : 'grey.300',
              color: 'grey.700',
              '&:hover': {
                backgroundColor: 'grey.400',
              },
              '&.Mui-selected': {
                backgroundColor: 'grey.400',
                color: 'grey.700',
                '&:hover': {
                  backgroundColor: 'grey.400',
                }
              }
            }}
          >
            <Typography variant="button">
              Propose Parcel Reservation
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {showReservationForm && (
        <ParcelReservationRequestForm selectedFeatureOnMap={selectedFeatureOnMap} />
      )}

      <Box sx={{ position: "relative", height: "90vh", overflow: "visible", paddingTop: '20px' }}>
        <ViewMap
          setSelectedFeatureOnMap={setSelectedFeatureOnMap}
          isEditable={false}
          showLegend={true}
          showPopup={false}
        />
      </Box>
    </>
  );
};

export default React.memo(ParcelReservationRelease);